import './Loader.css'

const Loader = () => {
    return (
        <div className='ld-container'>
            <div className="lds-grid"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div>
    )
}

export default Loader